import React, { createContext, useContext, useState, useEffect } from 'react';
import { getMe, logout as apiLogout } from '../services/api';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Silently check if user is authenticated via httpOnly cookie.
  // 401 errors are swallowed by the axios interceptor in api.js —
  // they are expected for logged-out visitors, not a real error.
  const checkAuth = async () => {
    try {
      const res = await getMe();
      // Check if this is a 401 (not authenticated) or silent response
      if (res.silent || !res.data || res.status === 401) {
        setUser(null);
      } else {
        setUser(res.data.data);
      }
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    checkAuth();
  }, []);

  const loginUser = async () => {
    // After login, re-check auth to populate user from cookie
    await checkAuth();
  };

  const logoutUser = async () => {
    try {
      await apiLogout();
    } catch {
      // ignore network errors
    }
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, loginUser, logout: logoutUser }}>
      {children}
    </AuthContext.Provider>
  );
};
